export default function Marquee() {
  const phrases = [
    "Soul",
    "Spanish",
    "Mediterranean",
    "Brunch & Champagne",
    "Houston, TX",
    "Homestyle Kitchen",
    "House-made Daily",
  ];
  const loop = [...phrases, ...phrases, ...phrases];

  return (
    <section
      data-testid="marquee-section"
      className="bg-[#7A2021] text-[#FDFBF7] py-6 border-y border-[#7A2021] overflow-hidden"
    >
      <div className="flex marquee-track whitespace-nowrap will-change-transform">
        {loop.map((p, i) => (
          <span
            key={i}
            className="font-serif-display italic text-3xl md:text-4xl px-10 flex items-center"
          >
            {p}
            <span className="ml-10 inline-block w-2 h-2 rounded-full bg-[#C98A4B]" />
          </span>
        ))}
      </div>
    </section>
  );
}
